/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssignRoleToUserRequestDto } from '../models';
// @ts-ignore
import type { InlineObject1Dto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { SuccessMessageDto } from '../models';
// @ts-ignore
import type { ToggleUserRoleRequestDto } from '../models';
// @ts-ignore
import type { ToggleUserRoleResponseDto } from '../models';
// @ts-ignore
import type { UserRolesResponseDto } from '../models';
/**
 * RestUserRolesApi - axios parameter creator
 * @export
 */
export const RestUserRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Przypisuje rolę do użytkownika. UWAGA: Można przypisywać tylko role zwykłe (nie systemowe). Role systemowe są nadawane automatycznie przez system. 
         * @summary Przypisz rolę do użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {AssignRoleToUserRequestDto} assignRoleToUserRequestDto Przypisanie roli do użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRoleToUser: async (userId: string, assignRoleToUserRequestDto: AssignRoleToUserRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assignRoleToUser', 'userId', userId)
            // verify required parameter 'assignRoleToUserRequestDto' is not null or undefined
            assertParamExists('assignRoleToUser', 'assignRoleToUserRequestDto', assignRoleToUserRequestDto)
            const localVarPath = `/api/v1/users-management/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignRoleToUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca listę ról przypisanych do użytkownika (z informacją o statusie aktywności)
         * @summary Pobierz role użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRoles: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserRoles', 'userId', userId)
            const localVarPath = `/api/v1/users-management/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Usuwa rolę od użytkownika. UWAGA: Role systemowe nie mogą być usunięte - można je tylko dezaktywować. 
         * @summary Usuń rolę od użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} roleId ID roli
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleFromUser: async (userId: string, roleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeRoleFromUser', 'userId', userId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('removeRoleFromUser', 'roleId', roleId)
            const localVarPath = `/api/v1/users-management/{userId}/roles/{roleId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Przełącza status aktywności roli dla użytkownika (włącz/wyłącz). Używane głównie dla ról systemowych, które nie mogą być usunięte. 
         * @summary Aktywuj/dezaktywuj rolę użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} roleId ID roli
         * @param {ToggleUserRoleRequestDto} toggleUserRoleRequestDto Zmiana statusu aktywności roli użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleUserRole: async (userId: string, roleId: number, toggleUserRoleRequestDto: ToggleUserRoleRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('toggleUserRole', 'userId', userId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('toggleUserRole', 'roleId', roleId)
            // verify required parameter 'toggleUserRoleRequestDto' is not null or undefined
            assertParamExists('toggleUserRole', 'toggleUserRoleRequestDto', toggleUserRoleRequestDto)
            const localVarPath = `/api/v1/users-management/{userId}/roles/{roleId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleUserRoleRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestUserRolesApi - functional programming interface
 * @export
 */
export const RestUserRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestUserRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Przypisuje rolę do użytkownika. UWAGA: Można przypisywać tylko role zwykłe (nie systemowe). Role systemowe są nadawane automatycznie przez system. 
         * @summary Przypisz rolę do użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {AssignRoleToUserRequestDto} assignRoleToUserRequestDto Przypisanie roli do użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignRoleToUser(userId: string, assignRoleToUserRequestDto: AssignRoleToUserRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignRoleToUser(userId, assignRoleToUserRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserRolesApi.assignRoleToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca listę ról przypisanych do użytkownika (z informacją o statusie aktywności)
         * @summary Pobierz role użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRoles(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRolesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRoles(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserRolesApi.getUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Usuwa rolę od użytkownika. UWAGA: Role systemowe nie mogą być usunięte - można je tylko dezaktywować. 
         * @summary Usuń rolę od użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} roleId ID roli
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRoleFromUser(userId: string, roleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRoleFromUser(userId, roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserRolesApi.removeRoleFromUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Przełącza status aktywności roli dla użytkownika (włącz/wyłącz). Używane głównie dla ról systemowych, które nie mogą być usunięte. 
         * @summary Aktywuj/dezaktywuj rolę użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} roleId ID roli
         * @param {ToggleUserRoleRequestDto} toggleUserRoleRequestDto Zmiana statusu aktywności roli użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleUserRole(userId: string, roleId: number, toggleUserRoleRequestDto: ToggleUserRoleRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToggleUserRoleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleUserRole(userId, roleId, toggleUserRoleRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserRolesApi.toggleUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestUserRolesApi - factory interface
 * @export
 */
export const RestUserRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestUserRolesApiFp(configuration)
    return {
        /**
         * Przypisuje rolę do użytkownika. UWAGA: Można przypisywać tylko role zwykłe (nie systemowe). Role systemowe są nadawane automatycznie przez system. 
         * @summary Przypisz rolę do użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {AssignRoleToUserRequestDto} assignRoleToUserRequestDto Przypisanie roli do użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRoleToUser(userId: string, assignRoleToUserRequestDto: AssignRoleToUserRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMessageDto> {
            return localVarFp.assignRoleToUser(userId, assignRoleToUserRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca listę ról przypisanych do użytkownika (z informacją o statusie aktywności)
         * @summary Pobierz role użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRoles(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserRolesResponseDto> {
            return localVarFp.getUserRoles(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Usuwa rolę od użytkownika. UWAGA: Role systemowe nie mogą być usunięte - można je tylko dezaktywować. 
         * @summary Usuń rolę od użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} roleId ID roli
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleFromUser(userId: string, roleId: number, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMessageDto> {
            return localVarFp.removeRoleFromUser(userId, roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Przełącza status aktywności roli dla użytkownika (włącz/wyłącz). Używane głównie dla ról systemowych, które nie mogą być usunięte. 
         * @summary Aktywuj/dezaktywuj rolę użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {number} roleId ID roli
         * @param {ToggleUserRoleRequestDto} toggleUserRoleRequestDto Zmiana statusu aktywności roli użytkownika
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleUserRole(userId: string, roleId: number, toggleUserRoleRequestDto: ToggleUserRoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ToggleUserRoleResponseDto> {
            return localVarFp.toggleUserRole(userId, roleId, toggleUserRoleRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestUserRolesApi - interface
 * @export
 * @interface RestUserRolesApi
 */
export interface RestUserRolesApiInterface {
    /**
     * Przypisuje rolę do użytkownika. UWAGA: Można przypisywać tylko role zwykłe (nie systemowe). Role systemowe są nadawane automatycznie przez system. 
     * @summary Przypisz rolę do użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {AssignRoleToUserRequestDto} assignRoleToUserRequestDto Przypisanie roli do użytkownika
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserRolesApiInterface
     */
    assignRoleToUser(userId: string, assignRoleToUserRequestDto: AssignRoleToUserRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMessageDto>;

    /**
     * Zwraca listę ról przypisanych do użytkownika (z informacją o statusie aktywności)
     * @summary Pobierz role użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserRolesApiInterface
     */
    getUserRoles(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserRolesResponseDto>;

    /**
     * Usuwa rolę od użytkownika. UWAGA: Role systemowe nie mogą być usunięte - można je tylko dezaktywować. 
     * @summary Usuń rolę od użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {number} roleId ID roli
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserRolesApiInterface
     */
    removeRoleFromUser(userId: string, roleId: number, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMessageDto>;

    /**
     * Przełącza status aktywności roli dla użytkownika (włącz/wyłącz). Używane głównie dla ról systemowych, które nie mogą być usunięte. 
     * @summary Aktywuj/dezaktywuj rolę użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {number} roleId ID roli
     * @param {ToggleUserRoleRequestDto} toggleUserRoleRequestDto Zmiana statusu aktywności roli użytkownika
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserRolesApiInterface
     */
    toggleUserRole(userId: string, roleId: number, toggleUserRoleRequestDto: ToggleUserRoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ToggleUserRoleResponseDto>;

}

/**
 * RestUserRolesApi - object-oriented interface
 * @export
 * @class RestUserRolesApi
 * @extends {BaseAPI}
 */
export class RestUserRolesApi extends BaseAPI implements RestUserRolesApiInterface {
    /**
     * Przypisuje rolę do użytkownika. UWAGA: Można przypisywać tylko role zwykłe (nie systemowe). Role systemowe są nadawane automatycznie przez system. 
     * @summary Przypisz rolę do użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {AssignRoleToUserRequestDto} assignRoleToUserRequestDto Przypisanie roli do użytkownika
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserRolesApi
     */
    public assignRoleToUser(userId: string, assignRoleToUserRequestDto: AssignRoleToUserRequestDto, options?: RawAxiosRequestConfig) {
        return RestUserRolesApiFp(this.configuration).assignRoleToUser(userId, assignRoleToUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca listę ról przypisanych do użytkownika (z informacją o statusie aktywności)
     * @summary Pobierz role użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserRolesApi
     */
    public getUserRoles(userId: string, options?: RawAxiosRequestConfig) {
        return RestUserRolesApiFp(this.configuration).getUserRoles(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Usuwa rolę od użytkownika. UWAGA: Role systemowe nie mogą być usunięte - można je tylko dezaktywować. 
     * @summary Usuń rolę od użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {number} roleId ID roli
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserRolesApi
     */
    public removeRoleFromUser(userId: string, roleId: number, options?: RawAxiosRequestConfig) {
        return RestUserRolesApiFp(this.configuration).removeRoleFromUser(userId, roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Przełącza status aktywności roli dla użytkownika (włącz/wyłącz). Używane głównie dla ról systemowych, które nie mogą być usunięte. 
     * @summary Aktywuj/dezaktywuj rolę użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {number} roleId ID roli
     * @param {ToggleUserRoleRequestDto} toggleUserRoleRequestDto Zmiana statusu aktywności roli użytkownika
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserRolesApi
     */
    public toggleUserRole(userId: string, roleId: number, toggleUserRoleRequestDto: ToggleUserRoleRequestDto, options?: RawAxiosRequestConfig) {
        return RestUserRolesApiFp(this.configuration).toggleUserRole(userId, roleId, toggleUserRoleRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

